"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ = require("../..");

var _bind = _interopRequireDefault(require("classnames/bind"));

var _SurveyValidation = require("./SurveyValidation");

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./SurveyQuestionForm.css");

var _styles = {
  "form-container": "SurveyQuestionForm__form-container___3UNer",
  "submission-actions": "SurveyQuestionForm__submission-actions___2ubRb",
  "reveal": "SurveyQuestionForm__reveal___1Z9Xn",
  "expandable-question": "SurveyQuestionForm__expandable-question___SfM1s",
  "sandwhich": "SurveyQuestionForm__sandwhich___34W9K",
  "sandwhich-header": "SurveyQuestionForm__sandwhich-header___2QS8s",
  "expanded": "SurveyQuestionForm__expanded___3CUUC",
  "sandwhich-footer": "SurveyQuestionForm__sandwhich-footer___1k6jE",
  "question": "SurveyQuestionForm__question___19U2W",
  "first": "SurveyQuestionForm__first___3o83h"
};

const styles = _bind.default.bind(_styles);

const SurveyQuestionForm = (0, _mobxReact.observer)(({
  className,
  dataTestId,
  questions,
  questionAnimation,
  questionAnimationStaggerSeconds = 0.25,
  answers,
  variant = 'individual',
  showErrors,
  additionalValidation,
  onAnswerChange,
  reveal,
  revealIndex,
  sandwhichHeader,
  sandwhichFooter,
  showSandwhichFooter,
  expandSandwhich = true,
  maxFileSize,
  acceptedFiletypes,
  onFileAdded,
  onFileCancelled,
  onFileRemoved,
  onFileProgressCompleted,
  onSubmit,
  submitButtonLabel = 'Submit',
  submitButtonRevealLabel = 'Continue',
  ...props
}) => {
  const composed_classname = (0, _bind.default)(styles('form-container', variant, {
    reveal,
    sandwhich: variant === 'sandwhich'
  }), className);
  const [surveyAnswers, setSurveyAnswers] = (0, _react.useState)(answers ? { ...answers
  } : {});
  const [questionFiles, setQuestionFiles] = (0, _react.useState)({});
  const [questionErrors, setQuestionErrors] = (0, _react.useState)({});
  const [recentQuestionAnswered, setRecentQuestionAnswered] = (0, _react.useState)({
    id: '',
    index: -1,
    time: 0
  });
  const [progressiveRevealIndex, setProgressiveRevealIndex] = (0, _react.useState)(revealIndex || 0);
  const [showFormErrors, setShowFormErrors] = (0, _react.useState)(showErrors || false);
  const [allQuestionsAnswered, setAllQuestionsAnswered] = (0, _react.useState)(false);
  const [allAnswersValidated, setAllAnswersValidated] = (0, _react.useState)(false);
  const [isSubmitting, setIsSubmitting] = (0, _react.useState)(false);
  const [submissionError, setSubmissionError] = (0, _react.useState)('');

  if (reveal && revealIndex === undefined && !onSubmit) {
    throw new Error(`revealIndex is required for SurveyQuestionForm if reveal is set to true`);
  }

  const isMounted = (0, _react.useRef)(false);
  (0, _react.useEffect)(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  (0, _react.useEffect)(() => {
    if (showErrors !== undefined) {
      setShowFormErrors(showErrors);
    }
  }, [showErrors]);
  (0, _react.useEffect)(() => {
    if (revealIndex !== undefined) {
      setProgressiveRevealIndex(revealIndex);
    }
  }, [revealIndex]);
  const recentQuestionAnsweredRef = (0, _react.useRef)({
    id: '',
    index: -1,
    time: 0
  });
  (0, _react.useEffect)(() => {
    const newQuestionErrors = questions.reduce((errors, question) => {
      var _a;

      if (question.answerType === 'file_upload') {
        const uploadedFile = (_a = questionFiles[question.id]) === null || _a === void 0 ? void 0 : _a.find(file => !!file.uploadCompletedAt);

        if (question.required && !uploadedFile) {
          errors[question.id] = question.errorText || `A file must be uploaded`;
        }
      } else {
        const value = surveyAnswers[question.id] !== undefined ? surveyAnswers[question.id] : question.answerValue;
        let errMsg = (0, _SurveyValidation.SurveyValidation)(question.answerValidationType || question.answerType, value, !!question.required);

        if (!errMsg && additionalValidation) {
          errMsg = additionalValidation(question, value) || null;
        }

        if (errMsg) {
          errors[question.id] = question.errorText || errMsg;
        }
      }

      return errors;
    }, {});
    const allRequiredAnswered = areAllRequiredQuestionsAnswered(progressiveRevealIndex);
    const allValidated = allRequiredAnswered && Object.keys(newQuestionErrors).length < 1;
    setQuestionErrors(newQuestionErrors);
    setAllQuestionsAnswered(allRequiredAnswered);
    setAllAnswersValidated(allValidated);

    if (onAnswerChange && (recentQuestionAnsweredRef.current.id !== recentQuestionAnswered.id || recentQuestionAnsweredRef.current.time !== recentQuestionAnswered.time)) {
      recentQuestionAnsweredRef.current.id = recentQuestionAnswered.id;
      recentQuestionAnsweredRef.current.time = recentQuestionAnswered.time;
      onAnswerChange({
        surveyAnswers,
        questionFiles,
        questionId: recentQuestionAnswered.id,
        index: recentQuestionAnswered.index,
        answer: surveyAnswers[recentQuestionAnswered.id] || '',
        allRequiredAnswered: allRequiredAnswered,
        allAnswersValidated: allValidated
      });
    }
  }, [questions, surveyAnswers, questionFiles, progressiveRevealIndex, recentQuestionAnswered]);

  const areAllRequiredQuestionsAnswered = questionIndex => {
    const revealedQuestions = reveal ? questions.slice(0, questionIndex + 1) : questions;
    return revealedQuestions.every(question => {
      if (question.required) {
        const value = surveyAnswers[question.id];

        if (question.answerType === 'file_upload') {
          const fileList = questionFiles[question.id];

          if (fileList === null || fileList === void 0 ? void 0 : fileList.length) {
            return fileList.some(file => !!file.uploadCompletedAt);
          } else {
            return false;
          }
        } else if (Array.isArray(value) && !value.length) {
          return false;
        } else if (!value) {
          return false;
        }
      }

      return true;
    });
  };

  const renderQuestion = (question, index) => {
    const triggerFileEventCallback = (callback, file, allFiles) => {
      setRecentQuestionAnswered({
        id: question.id,
        index,
        time: Date.now()
      });
      setQuestionFiles({ ...questionFiles,
        [question.id]: allFiles
      });
      callback && callback(question, file, allFiles);
    };

    const getRealValue = (value, rawValue) => {
      if (question.required) {
        return value;
      } else if (rawValue === '') {
        return undefined;
      } else {
        return value;
      }
    };

    return _react.default.createElement(_.SurveyQuestion, {
      className: styles('question', {
        first: index === 0
      }),
      key: question.id,
      dataTestId: dataTestId ? `${dataTestId}-${question.id}` : undefined,
      text: question.text,
      subtitle: question.subtitle,
      answerType: question.answerType,
      answerOptions: question.answerOptions,
      answerValue: surveyAnswers[question.id] || question.answerValue,
      placeholder: question.placeholder,
      tooltip: question.tooltip,
      helperText: question.helperText,
      error: showFormErrors && !!questionErrors[question.id],
      errorText: questionErrors[question.id],
      withCard: variant === 'individual',
      withCardMargin: false,
      maxFileSize: maxFileSize,
      acceptedFiletypes: acceptedFiletypes,
      onFileAdded: (file, allFiles) => triggerFileEventCallback(onFileAdded, file, allFiles),
      onFileCancelled: (file, allFiles) => triggerFileEventCallback(onFileCancelled, file, allFiles),
      onFileRemoved: (file, allFiles) => triggerFileEventCallback(onFileRemoved, file, allFiles),
      onFileProgressCompleted: (file, allFiles) => triggerFileEventCallback(onFileProgressCompleted, file, allFiles),
      onChange: (value, rawValue) => {
        const realValue = getRealValue(value, rawValue);

        if (realValue === undefined) {
          if (surveyAnswers[question.id]) {
            delete surveyAnswers[question.id];
          }
        } else {
          surveyAnswers[question.id] = realValue;
        }

        setRecentQuestionAnswered({
          id: question.id,
          index,
          time: Date.now()
        });
        setSurveyAnswers({ ...surveyAnswers
        });
      }
    });
  };

  const renderQuestionAnimation = (question, index, variantAnimations) => {
    if (!questionAnimation && !variantAnimations) {
      return renderQuestion(question, index);
    }

    const props = typeof questionAnimation === 'string' || Array.isArray(questionAnimation) ? {
      enter: questionAnimation
    } : questionAnimation || variantAnimations || {};
    return _react.default.createElement(_.Animate, {
      key: question.id,
      ...props,
      delay: variantAnimations && !questionAnimation ? 0 : index * questionAnimationStaggerSeconds
    }, renderQuestion(question, index));
  };

  const onSubmitClick = async () => {
    setSubmissionError('');

    if (!allAnswersValidated) {
      setShowFormErrors(true);
      return;
    }

    if (reveal && progressiveRevealIndex < questions.length - 1) {
      setShowFormErrors(false);
      setAllQuestionsAnswered(areAllRequiredQuestionsAnswered(progressiveRevealIndex + 1));
      setProgressiveRevealIndex(progressiveRevealIndex + 1);
      return;
    }

    if (onSubmit) {
      setIsSubmitting(true);

      try {
        const error = await onSubmit(surveyAnswers, questionFiles);

        if (!isMounted.current) {
          return;
        }

        if (error) {
          setSubmissionError(error);
        }
      } catch (e) {
        if (!isMounted.current) {
          return;
        }

        if (typeof e === 'string') {
          setSubmissionError(e);
        } else {
          setSubmissionError(`Something went wrong, please try again.`);
        }
      }

      setIsSubmitting(false);
    }
  };

  const renderFooter = () => {
    if (!onSubmit) {
      return;
    }

    return _react.default.createElement("div", {
      className: styles('submission-actions')
    }, _react.default.createElement(_.Button, {
      dataTestId: dataTestId ? `${dataTestId}-submit-button` : '',
      small: true,
      label: reveal && progressiveRevealIndex < questions.length - 1 ? submitButtonRevealLabel : submitButtonLabel,
      disabled: !allQuestionsAnswered || showFormErrors && !allAnswersValidated,
      loading: isSubmitting,
      onClick: onSubmitClick
    }), !isSubmitting && !!submissionError && _react.default.createElement(_.Text, {
      dataTestId: dataTestId && `${dataTestId}-submission-error`,
      status: `failed`,
      text: submissionError
    }));
  };

  if (variant === 'sandwhich') {
    return _react.default.createElement(_.Card, {
      noMargin: true,
      className: composed_classname,
      dataTestId: dataTestId,
      ...props
    }, sandwhichHeader && _react.default.createElement("div", {
      className: styles('sandwhich-header', {
        expanded: expandSandwhich
      })
    }, sandwhichHeader), _react.default.createElement(_.Expandable, {
      expand: expandSandwhich,
      duration: 500
    }, questions.map((question, index) => renderQuestionAnimation(question, index, {
      enter: ['fade-in']
    }))), showSandwhichFooter === undefined ? _react.default.createElement("div", {
      className: styles('sandwhich-footer')
    }, sandwhichFooter || renderFooter()) : _react.default.createElement(_.Expandable, {
      expand: showSandwhichFooter,
      duration: 500
    }, _react.default.createElement("div", {
      className: styles('sandwhich-footer')
    }, sandwhichFooter || renderFooter())));
  }

  return _react.default.createElement("div", {
    className: composed_classname,
    "data-testid": dataTestId,
    ...props
  }, reveal ? _react.default.createElement(_.ProgressiveStepper, {
    currentStep: progressiveRevealIndex + 1
  }, questions.map((question, index) => {
    return _react.default.createElement(_.Expandable, {
      expand: true,
      key: `${dataTestId || `survey-form`}-${question.id}`
    }, _react.default.createElement("div", {
      className: styles('expandable-question')
    }, renderQuestionAnimation(question, index)));
  })) : questions.map((question, index) => renderQuestionAnimation(question, index)), renderFooter());
});
var _default = SurveyQuestionForm;
exports.default = _default;